import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';

  ngOnDestroy(): void {
    localStorage.removeItem('textos_TMTY');
  }

}
